document.addEventListener('DOMContentLoaded', function () {

  const catagorybestswiper = new Swiper('.catagory-best-selling-area', {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 24,
          navigation: {
              nextEl: '.best-selling-swiper-button-next',
              prevEl: '.best-selling-swiper-button-prev',
          },
          pagination: {
            el: '.best-selling-pagination',
            clickable: true,
          },
          breakpoints: {
          1025: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 24,
          },
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 20,
          },
          0: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 15,
          }
        },
         on: {
        init: function () {
          besttoggleArrowVisibility(this);
        },
        resize: function () {
          besttoggleArrowVisibility(this);
        }
      }
      });
 
   //Best Selling Section
   const bestswiper = new Swiper('.all-best-selling-area', {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 24,
          navigation: {
              nextEl: '.best-selling-swiper-button-next',
              prevEl: '.best-selling-swiper-button-prev',
          },
          pagination: {
            el: '.best-selling-pagination',
            clickable: true,
          },
          breakpoints: {
          1025: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          768: {
            slidesPerView: 2.5,
            slidesPerGroup: 2,
            spaceBetween: 20,
          },
          0: {
            slidesPerView: 1.6,
            slidesPerGroup: 2,
            spaceBetween: 15,
          }
        },
         on: {
        init: function () {
          besttoggleArrowVisibility(this);
        },
        resize: function () {
          besttoggleArrowVisibility(this);
        }
      }
      });

      const sizebestswiper = new Swiper('.size-product-area', {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 24,
          navigation: {
              nextEl: '.best-selling-swiper-button-next',
              prevEl: '.best-selling-swiper-button-prev',
          },
          pagination: {
            el: '.best-selling-pagination',
            clickable: true,
          },
          breakpoints: {
          1025: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          768: {
            slidesPerView: 2.5,
            slidesPerGroup: 2,
            spaceBetween: 20,
          },
          0: {
            slidesPerView: 1.26,
            slidesPerGroup: 2,
            spaceBetween: 20,
          }
        },
         on: {
        init: function () {
          besttoggleArrowVisibility(this);
        },
        resize: function () {
          besttoggleArrowVisibility(this);
        }
      }
      });

  function besttoggleArrowVisibility(swiper) {
      const totalSlides = swiper.slides.length;
      const arrowArea = swiper.el.closest('.pdp-best-selling-section')?.querySelector('.arrow-area');
      const screenWidth = window.innerWidth;
    
      if (!arrowArea) return;
    
      // On desktop, hide arrows if 3 or fewer slides
      if (screenWidth >= 1025 && totalSlides <= 4) {
        arrowArea.classList.add('hidden');
      } else {
        arrowArea.classList.remove('hidden');
      }
    }
    
  //pdp video list slider
   const pdpswiper = new Swiper('.pdp_video_list_area', {
          slidesPerView: 3.6,
          gap:14,
          slidesPerGroup: 1,
          spaceBetween: 14,
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
         breakpoints: {
              1025: {
                slidesPerView: 3.6,
              },
              768: {
                slidesPerView: 2.4,
                spaceBetween: 10,
              },
              0: {
                slidesPerView: 2.8,
                spaceBetween: 14,
              }
            }
      });

    //homepage testimonial review slider
    const reviewswiper = new Swiper('.testimonial-slider-wrapper', {
      slidesPerGroup: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.testimonual-swiper-button-next',
        prevEl: '.testimonual-swiper-button-prev',
      },
      breakpoints: {
        5000: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        989: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 15,
        },
        480: {
          slidesPerView: 1.3,
          spaceBetween: 15,
        },
        360: {
          slidesPerView: 1.3,
          spaceBetween: 15,
        }
      }
    });
  
      //homepage Traditional Design review slider
         const traditionalswiper = new Swiper('.traditional-design-wrapper', {
                slidesPerView: 1,
                gap:24,
                slidesPerGroup: 1,
                spaceBetween: 30,
                navigation: {
                    nextEl: '.traditional-design-swiper-button-next',
                    prevEl: '.traditional-design-swiper-button-prev',
                },
            });

  const knifeswiper = new Swiper('.knife-features-area', {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 24,
      navigation: {
        nextEl: '.best-selling-swiper-button-next',
        prevEl: '.best-selling-swiper-button-prev',
      },
      breakpoints: {
        1025: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 20,
        },
        0: {
          slidesPerView: 1.36,
          slidesPerGroup: 1,
          spaceBetween: 16,
        }
      },
      on: {
        init: function () {
          toggleArrowVisibility(this);
        },
        resize: function () {
          toggleArrowVisibility(this);
        }
      }
    });
    
    function toggleArrowVisibility(swiper) {
       const totalSlides = swiper.slides.length;
        const arrowArea = swiper.el.closest('.knife-features-section')?.querySelector('.arrow-area');
        const screenWidth = window.innerWidth;
      
        if (!arrowArea) return;
      
        if (screenWidth >= 1025 && totalSlides <= 3) {
          arrowArea.classList.add('hidden');
        } else {
          arrowArea.classList.remove('hidden');
        }
    }
  
});  


// table js start

function applyResponsiveStyle() {
  const lastIconRow = document.querySelector('tr.table_row.last_icons');
  const prevRow = lastIconRow?.previousElementSibling;

  if (!prevRow?.classList.contains('table_row')) return;

  const tds = prevRow.querySelectorAll('td');

  if (window.matchMedia("(max-width: 767px)").matches) {
    tds.forEach(td => {
      td.classList.add('no-border');
      td.style.paddingBottom = '0';
    });
  } else {
    tds.forEach(td => {
      td.classList.remove('no-border');
      td.style.paddingBottom = '';
    });
  }
}

applyResponsiveStyle();
window.addEventListener('resize', applyResponsiveStyle);


jQuery(function ($) {
  $('details').each(function () {
    var $details = $(this);
    var $summary = $details.children('summary').first();
    var $content = $details.children('.accordion__content').first();
 
    if ($details.is('[open]')) {
      $content.show();
      $summary.attr('aria-expanded', 'true');
    } else {
      $content.hide();
      $summary.attr('aria-expanded', 'false');
    }
  });
 
  $(document).on('click', 'details > summary', function (e) {
    e.preventDefault();
 
    var $summary = $(this);
    var $details = $summary.parent('details');
    var $content = $details.children('.accordion__content').first();
 
    var isOpen = $details.is('[open]');
 
    if (isOpen) {
      $summary.attr('aria-expanded', 'false');
      $content.stop(true, true).slideUp(200, function () {
        $details.removeAttr('open');
      });
    } else {
      $details.attr('open', '');
      $summary.attr('aria-expanded', 'true');
      $content.stop(true, true).hide().slideDown(200);
    }
  });
});
 
document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("featurevideo");
  const section = document.querySelector(".video-feature-section");
  const toggleBtn = document.getElementById("featurevideoToggle");
  const playIcon = toggleBtn.querySelector(".icon--play");
  const pauseIcon = toggleBtn.querySelector(".icon--pause");
 
  function updateIcons() {
    if (video.paused) {
      playIcon.style.display = "inline-block";
      pauseIcon.style.display = "none";
    } else {
      playIcon.style.display = "none";
      pauseIcon.style.display = "inline-block";
    }
  }
 
  toggleBtn.addEventListener("click", function () {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
    updateIcons();
  });
 
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          video.play().catch(err => console.log("Autoplay blocked:", err));
        } else {
          video.pause();
        }
        updateIcons();
      });
    },
    { threshold: 0.5 }
  );
 
  observer.observe(section);
 
  video.addEventListener("play", updateIcons);
  video.addEventListener("pause", updateIcons);
 
  updateIcons();
});
 
jQuery(document).ready(function($) {
  $(".header_search_icon").on("click", function() {
    $(".search-modal").addClass("active");
    $(this).hide();
    $(".header__icon-close").show();
  });

  $(".header__icon-close").on("click", function() {
    $(".search-modal").removeClass("active");
    $(this).hide();
    $(".header_search_icon").show();
  });
});